import ApiClient from '../shared/ApiCliente';

export type CreateAdminUserRequest = {
  email: string;
  temporaryPassword: string;
  name?: string;
  phoneNumber?: string;
  cpf?: string;
  grupoCognito?: string;
};

export type CreateAdminUserResponse = {
  username: string;
  email: string;
  status: string;
  grupoCognito?: string;
};

export type AdminUserListItem = {
  username: string;
  email: string;
  name?: string;
  enabled: boolean;
  status: string;
  grupos: string[];
};

export type AdminUserListResponse = {
  usuarios: AdminUserListItem[];
  nextToken?: string | null;
  hasMore: boolean;
};

export const adminUserService = {
  create: async (payload: CreateAdminUserRequest): Promise<CreateAdminUserResponse> => {
    const response = await ApiClient.post<CreateAdminUserResponse>('/usuario/admin', payload);
    return response.data;
  },

  list: async (params?: { limit?: number; nextToken?: string }): Promise<AdminUserListResponse> => {
    const response = await ApiClient.get<AdminUserListResponse>('/usuario/admin/usuarios', {
      params: params || {},
    });
    return response.data;
  },
};
